import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export const useStorePc = () => {
  const [isStorePc, setIsStorePc] = useState(false);

  useEffect(() => {
    setIsStorePc(!!Cookies.get('storepc'));
  }, []);

  return isStorePc;
};
